import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypes = () => {
  const dispatch = useDispatch();

  const options = useSelector(
    (state) => state.averageNumberOfVisitsPerClient.filters.membership_types
  );
  const selectedFilters = useSelector(
    (state) => state.averageNumberOfVisitsPerClient.selectedFilters.membership_types
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      placeholder="Select Action"
      height={324}
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={(data) => dispatch(actionCreators.updateMembershipTypes(data))}
    />
  );
};

export default MembershipTypes;
